import React from 'react';
import { Heading, Box, Text } from '@chakra-ui/react';

const Settings = () => {
  const items = ['Item 1', 'Item 2', 'Item 3', 'Item 4'];

  return (
    <div>
      <Heading>List Page</Heading>
      <Box mt={4}>
        {items.map((item, index) => (
          <Box key={index} p={4} borderWidth="1px" borderRadius="md" mb={2}>
            <Text>{item}</Text>
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default Settings;
